export const colorArray = [
  {
    background_color: 'blue',
    backGround: 'image/color/img_blue.png',
    backGroundMini: 'image/color/img_blue_mi.png',
    background_text: ''
  },
  {
    background_color: 'violet',
    backGround: 'image/color/img_violet.png',
    backGroundMini: 'image/color/img_violet_mi.png',
    background_text: ''
  },
  {
    background_color: 'green',
    backGround: 'image/color/img_green.png',
    backGroundMini: 'image/color/img_green_mi.png',
    background_text: ''
  },
  {
    background_color: 'pink',
    backGround: 'image/color/img_pink.png',
    backGroundMini: 'image/color/img_pink_mi.png',
    background_text: ''
  },
  {
    background_color: 'yellow',
    backGround: 'image/color/img_yellow.png',
    backGroundMini: 'image/color/img_yellow_mi.png',
    background_text: ''
  },
  {
    background_color: 'sea',
    backGround: 'image/color/img_sea.png',
    backGroundMini: 'image/color/img_sea_mi.png',
    background_text: ''
  }
]
